const PREFIX = 'UI_';

const uiConstants = {
  DATE_FORMAT: 'DD/MM/YYYY',
  DATE_FORMAT_AWS: 'YYYYMMDD',
  DATE_FORMAT_FOR_PICKER: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm:ss',
  DATETIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  DATE_FORMAT_DATEPICKER: 'dd/MM/yyyy',
  MINUTE_TIME_FORMAT: 'MMM D hh:mm A',

  MODE_DAILY_PRICE: 10,
  MODE_CCASS_SUMMARY: 100,
  MODE_CCASS_NEWS: 1000,

  PAGE_CCASS_DATE_CHANGED: PREFIX + 'PAGE_CCASS_DATE_CHANGED',
  PAGE_CCASS_COMPARE_DATE_CHANGED: PREFIX + 'PAGE_CCASS_COMPARE_DATE_CHANGED',
  PAGE_CCASS_STOCKCODE_CHANGED: PREFIX + 'PAGE_CCASS_STOCKCODE_CHANGED',
  PAGE_CCASS_STOCKNAME_CHANGED: PREFIX + 'PAGE_CCASS_STOCKNAME_CHANGED',
  PAGE_CCASS_PARTICIPANTID_CHANGED: PREFIX + 'PAGE_CCASS_PARTICIPANTID_CHANGED',
  PAGE_CCASS_PARTICIPANTNAME_CHANGED:
    PREFIX + 'PAGE_CCASS_PARTICIPANTNAME_CHANGED',

  PAGE_STOCK_STOCKCODE_CHANGED: PREFIX + 'PAGE_STOCK_STOCKCODE_CHANGED',

  SET_FREEUSER_ALERT: PREFIX + 'SET_FREEUSER_ALERT',

  FORCE_CLIENT_UPGRADE: PREFIX + 'FORCE_CLIENT_UPGRADE',

  SET_FLOAT_TUTORIAL_ID: PREFIX + 'SET_FLOAT_TUTORIAL_ID',
  SET_QUESTION_MARK_VISIBLE: PREFIX + 'SET_QUESTION_MARK_VISIBLE',
};

export default uiConstants;
